export default "__VITE_ASSET__C6JL0WfH__"